import { useSuspenseQuery } from "@tanstack/react-query"
import { getRouteApi } from "@tanstack/react-router"
import { Suspense } from "react"
import { EmptyChildrenState } from "@/features/children/EmptyChildrenState"
import { useSelectedChild } from "@/features/children/useSelectedChild"
import { PageLoader } from "@/shared/components/PageLoader"
import { statisticsQueryOptions } from "./api/statistics.queries"
import { DriftChart } from "./DriftChart"
import { RangePicker } from "./RangePicker"
import { SleepBarsChart } from "./SleepBarsChart"
import type { StatisticsRange } from "./statistics.config"

const route = getRouteApi("/_app/statistik")

export function StatisticsPage() {
  const { selectedChild } = useSelectedChild()

  if (!selectedChild) {
    return <EmptyChildrenState />
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <StatisticsView
        key={selectedChild.id}
        childId={selectedChild.id}
        childName={selectedChild.name}
      />
    </Suspense>
  )
}

function StatisticsView({ childId, childName }: { childId: string; childName: string }) {
  const { range } = route.useSearch()
  const navigate = route.useNavigate()
  const { data } = useSuspenseQuery(statisticsQueryOptions(childId, range))

  const onRangeChange = (next: StatisticsRange) => {
    navigate({ search: { range: next } })
  }

  return (
    <main className="flex flex-col gap-4 p-4">
      <h1 className="text-lg font-semibold">Statistik</h1>
      <p className="text-xs text-muted-foreground">
        Rekommenderat sömnbehov för {childName} är {data.recommendation.minHours}–
        {data.recommendation.maxHours} h/dygn
      </p>
      <RangePicker value={range} onChange={onRangeChange} />
      <SleepBarsChart days={data.days} recommendation={data.recommendation} />
      <DriftChart nights={data.nights} />
    </main>
  )
}
